import React from "react";

// CSS
import classes from "./AnalyticsCard.module.css";
import { Container, Icon, Text } from "@jds/core";

export default function AnalyticsCard(props) {
  const { icon, heading, data, onClick = () => {} } = props;
  return (
    <div
      className={classes.card}
      onClick={() => {
        onClick();
      }}
    >
      <Container fullWidth gap={16}>
        <Icon
          ic={icon || "IcRupee"}
          kind="background"
          size="large"
          {...props.icProps}
        />
        <Container direction="column" gap={4}>
          <Text
            appearance="body-xs-bold"
            text={heading || "Heading"}
            color="primary-grey-80"
          />
          <Text appearance="body-m-bold" text={data || "0"} />
        </Container>
      </Container>
    </div>
  );
}
